import { useQuery } from '@tanstack/react-query';

import type { BankFeedAccountType } from '@/domain/bankFeed/schemas';
import { bankFeedTransactionsAutocompleteQuery } from '@/domain/bankFeed/queries/transactionsAutocomplete';

// Backend-driven grid column id carrying the CARD payment date (value_date). The toolbar
// payment-date filter reuses the generic column-filter autocomplete endpoint (grid/autocomplete)
// with this field — the backend dropped the dedicated value-dates endpoint (DA-19485).
const PAYMENT_DATE_FIELD = 'value_date';

// CARD payment-date filter options (DA-19485): reuses the shared grid/autocomplete endpoint with
// the value_date field. Enabled once a card and currency resolve.
export const useBankFeedValueDates = (
  accountType: BankFeedAccountType,
  accountId: string | null,
  currency: string | null,
) =>
  useQuery({
    ...bankFeedTransactionsAutocompleteQuery({
      field: PAYMENT_DATE_FIELD,
      accountType,
      currency: currency ?? '',
      accountIds: accountId != null ? [accountId] : [],
    }),
    enabled: accountId != null && currency != null,
    // Payment dates change only when new transactions sync, so override the reused autocomplete
    // query's staleTime:0 (refetch on every mount/focus) — 10 min balances freshness vs churn.
    staleTime: 10 * 60_000,
  });
